/**
 *
 * @param {import("axios").AxiosInstance} repository
 */
export default function actions({ repository } = {}) {
  const path = `/v2/organization/`;
  return {
    /**
     *
     * @param {Object} param0
     * @param {String} param0.id ID of course
     * @param {String} param0.type Type of access
     * @returns {Array}
     */
    async get({ id, type } = {}) {
      return await repository
        .get(`${path}${type}/day`, { params: { cid: id } })
        .then(response => {
          return Promise.resolve(response.data.object);
        });
    },
    async getOne({ id, did, type } = {}) {
      let days = await this.get({ id, type });
      let found = days.filter(day => {
        return String(day._id) == String(did);
      });
      return found.pop();
    },
    /**
     * Returns a day object, on success
     * @param {String} param0.id Course ID
     */
    async create({ id, type } = {}) {
      return await repository
        .post(`${path}${type}/day?cid=${id}`)
        .then(response => {
          return Promise.resolve(response.data.object.day);
        });
    },
    /**
     *
     * @param {String} param0.id ID of the course to update
     * @param {String} param0.did ID of the day to update
     * @param {Object} param0.coursedoc Document to update
     * @return A course object
     */
    async update({ id, did, daydoc, type } = {}) {
      //axios.put(`/organization/${path}/day?cid=${courseid}&id=${dayid}`, day)
      return await repository
        .put(`${path}${type}/day?cid=${id}&id=${did}`, daydoc)
        .then(response => {
          return Promise.resolve(true);
        });
    },
    /**
     *
     * @param {String} param0.id Course ID
     * @param {String} param0.did
     */
    async delete({ id, did, type } = {}) {
      return await repository.delete(`${path}${type}/day?cid=${id}&id=${did}`);
    }
  };
}
